module.exports = __webpack_public_path__ + "img/vatican-city.33151433.svg";